import { createFileRoute } from '@tanstack/react-router'
import { TicketListView } from '@/features/ticket-list/TicketListView'

function Inbox() {
  const { asUser } = Route.useSearch()
  return <TicketListView asUser={asUser} />
}

export const Route = createFileRoute('/tickets/')({
  // The lens lives in the URL so it is shareable and cannot become a hidden
  // sticky mode a staff member forgets they are in.
  validateSearch: (raw: Record<string, unknown>): { asUser?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined,
  }),
  component: Inbox,
})
